import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Dialog, DialogContent } from '@material-ui/core';
import moment from 'moment';

import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { StepperFormExpediente } from '../MesaEntradaRecepcion/StepperFormExpediente';
import {
  ESTADOS_COMRPOBANTES,
  MENU_TIPO_EXPEDIENTE,
  PROCEDENCIA,
  STEPPER_EXPEDIENTE_FORM,
  STEPPER_EXPEDIENTE_PROFORMA_FORM,
  TIPO_COMPROBANTE,
  TIPO_COMPROBANTE_DOCUMENTO,
  TIPO_EFECTORES,
  TRAMITE_COMPROBANTE_DOCUMENTO,
  TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES,
  TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES,
} from '../../../utils/constants';
import { useForm } from '../../../hooks/useForm';
import {
  cleanComprobantesMesaEntrada,
  cleanProformasMesaEntrada,
  getProformas,
  liberarComprobanteMesaEntrada,
  liberarProformaMesaEntrada,
  postComprobante,
  setActiveStepMesaEntrada,
  setMenuProformaMesaEntrada,
  setRecepcionMenu,
  tomarProformaMesaEntrada,
} from '../../../actions/mesaEntrada/mesaEntradaActions';
import { startAlerta } from '../../../actions/ui/alertas';
import { dataProformaForm } from '../data/datosProformaForm';
import { useToggle } from '../../../hooks/useToggle';
import { ModalInformacionExpediente } from './ModalInformacionExpediente';
import { cleanCuentasContables } from '../../../actions/contrataciones/contratacionesDatosContables';
import { desSeleccionarContrato } from '../../../actions/contrataciones/contrataciones';
import { setProveedor } from '../../../actions/compras/ProveedoresAction';
import { useMesaEntrada } from '../../../hooks/useCases/useMesaEntrada';

const AddButtonComprobante = ({
  handleSave,
  permiso,
  presupuesto,
  proforma,
  cotizacion,
}) => {
  const dispatch = useDispatch();
  const mesa = useMesaEntrada();

  const { permisos: permisosUser, areasFisicasUsuario } = useSelector(
    (state) => state.auth,
  );
  const [open, setOpen] = useState(false);
  const [conEmbargo, toggleEmbargo] = useToggle();
  const [openModalInformacion, setOpenModalInformacion] = useState(false);

  const tieneAreaMesa = areasFisicasUsuario.subAreaFisica !== null;

  const {
    recepcionMenu,
    comprobanteTomado,
    tipoEfectorMenu,
    proformas,
    menuProforma,
    activeStep,
    tipoComprobanteDocumentoMenu,
  } = useSelector((state) => state.mesaEntrada);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { cuentas } = useSelector(
    (state) => state.contratacionesDatosBancarios,
  );

  const menuPrestador = recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
  const idTramite = cotizacion ? TRAMITE_COMPROBANTE_FACTURACION_PROVEEDORES.COMPRAS_INSUMOS_MEDICOS
    : menuPrestador
    ? tipoEfectorMenu !== TIPO_EFECTORES.INTEGRACION
      ? ''
      : TRAMITE_COMPROBANTE_FACTURACION_PRESTADORES.INTEGRACION
    : tipoComprobanteDocumentoMenu !== TIPO_COMPROBANTE_DOCUMENTO.EMBARGO
      ? ''
      : TRAMITE_COMPROBANTE_DOCUMENTO.EMBARGO;

  // let totalCotizacion = 0;
  // cotizacion?.cabeceraCotizacion
  //   .map(({detalleCotizaciones}) => detalleCotizaciones
  //   .map(({valorUnitario, cantidadCotizada}) => totalCotizacion = totalCotizacion + (+valorUnitario * +cantidadCotizada)));

  const dataExpediente = {
    idTipoExpediente: recepcionMenu,
    idTramite,
    idDestino:
      mesa.data.tramites.find((item) => item.idTramite === idTramite)
        ?.idDestino || '',
    idEstado: ESTADOS_COMRPOBANTES.ENVIADA,
    fechaRecepcion: moment().format(),
    fechaCarga: moment().format(),
    observaciones: '',
    idArea: tieneAreaMesa ? areasFisicasUsuario?.subAreaFisica?.idSubArea : '',
  };

  const dataComprobante = menuPrestador
    ? {
      ...dataExpediente,
      idEfectorFacturacion: dataContrato?.idEfectorFacturacion,
      totalComprobante: cotizacion ? cotizacion?.valorCotizacion
        : presupuesto ? presupuesto?.valor : '',
      idTipoComprobante: cotizacion ? TIPO_COMPROBANTE.COTIZACION 
        : presupuesto ? TIPO_COMPROBANTE.PRESUPUESTO 
        : TIPO_COMPROBANTE.FACTURA,
      idProcedencia: PROCEDENCIA.MAIL,
      idTipoFactura: dataContrato?.idTipoFactura,
      caiCae: '',
      internacion: false,
      ambulatoria: false,
      nroFactura: '',
      nroSucursal: '',
      fechaInicioVigencia: cotizacion ? moment(cotizacion.fechaCotizacion) : null,
      fechaFinVigencia: moment()
        .add(dataContrato?.plazoPago, 'days')
        .format(),
      proveedor: tipoEfectorMenu === TIPO_EFECTORES.PROVEEDOR ? true : false,
      idTipoEfector: tipoEfectorMenu,
      ...(presupuesto &&
        {
          idPresupuesto: presupuesto.idPresupuesto,
          idAfiliado: presupuesto.idAfiliado,
          valorPresupuesto: presupuesto.valor,
        }
      ),
      ...(tipoEfectorMenu === TIPO_EFECTORES.PROVEEDOR && {
        cuentasContables: cuentas.map((item) => ({
          idCuentaContable: item.id,
          importeCuenta: 0,
          asignada: cuentas.length > 1 ? false : true,
        })),
        ...(cotizacion ? {
          idCotizacion: cotizacion.idCotizacion,
          idAfiliado: cotizacion.solicitud.idAfiliado,
          valorCotizacion: cotizacion?.valorCotizacion,
        } : {})
      }),
      ...(tipoEfectorMenu === TIPO_EFECTORES.INTEGRACION && {
        nroAutorizacion: '',
        periodoFacturado: '',
        recuperoSur: '',
        codNom: '',
        cantidad: '',
        valorUnitario: '',
        // debito: '',
        cantidadModificada: '',
        totalModificado: '',
        cantidadFacturada: '',
      }),
    }
    : {
      ...dataExpediente,
      ...(conEmbargo
        ? {
          idProcedencia: PROCEDENCIA.OTRAS_AREAS,
          cuit: '',
          cbuEmbargo: '',
          importe: '',
          autos: '',
        }
        : {
          idProcedencia: PROCEDENCIA.MAIL,
          idAfiliado: '',
          fechaCarta: null,
          caratula: '',
          entregadoPor: '',
          folios: '',
        }),
    };

  const dataProforma = dataProformaForm(
    proforma,
    tipoEfectorMenu,
    dataContrato?.idTipoFactura,
  );

  const [
    formValues,
    handleInputChange,
    resetForm,
    setearValor,
    setearValores,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    proforma ? { ...dataComprobante, ...dataProforma } : dataComprobante,
  );

  const handleClickOpen = () => {
    if (tieneAreaMesa) {
      resetForm();
      dispatch(
        setActiveStepMesaEntrada(STEPPER_EXPEDIENTE_FORM.TRAMITE_COMPROBANTE),
      );
      dispatch(liberarComprobanteMesaEntrada());
      if (proforma) {
        dispatch(setMenuProformaMesaEntrada(false));
        dispatch(tomarProformaMesaEntrada(proforma));
      } else {
        dispatch(setMenuProformaMesaEntrada(true));
      }
      setOpen(true);
    } else {
      dispatch(
        startAlerta(
          'El usuario no posee area Alberti o area Matheu.',
          'error',
          'Carga de Comprobante',
        ),
      );
    }
  };

  const handleClose = (reset) => {
    resetForm();
    dispatch(
      setActiveStepMesaEntrada(STEPPER_EXPEDIENTE_FORM.TRAMITE_COMPROBANTE),
    );
    if (proforma && comprobanteTomado !== null) {
      dispatch(getProformas());
    }
    if (comprobanteTomado?.idExpediente) {
      dispatch(postComprobante(comprobanteTomado));
      dispatch(
        startAlerta(
          `Comprobante nro: ${comprobanteTomado?.idExpediente} / Comprobante SV nro: ${comprobanteTomado?.idExpedientes}  Guardado`,
          'success',
          'Comando Exitoso',
          false
        ),
      );
    }
    dispatch(setMenuProformaMesaEntrada(false));
    dispatch(liberarProformaMesaEntrada());
    setOpen(false);

    if (comprobanteTomado !== null) setOpenModalInformacion(true);
    if (reset) {
      dispatch(cleanComprobantesMesaEntrada());
      dispatch(cleanProformasMesaEntrada());
      dispatch(cleanCuentasContables());
      dispatch(desSeleccionarContrato());
      dispatch(setProveedor(null));
      dispatch(setRecepcionMenu(MENU_TIPO_EXPEDIENTE.DESELECCIONAR));
    }
  };

  const checkContrato = () => {
    if (
      dataContrato?.fechaBaja !== null &&
      moment(dataContrato?.fechaBaja).add(90, 'days').format('YYYY-MM-DD') <
      moment().format('YYYY-MM-DD')
    ) {
      dispatch(
        startAlerta(
          'El plazo de carga supero los 90 días de la fecha de baja del contrato',
          'warning',
          'Carga de Comprobante',
        ),
      );
    } else if (
      !dataContrato?.idDatosBancarios ||
      dataContrato?.plazoPago === null
    ) {
      dispatch(
        startAlerta(
          'El contrato no posee Datos Bancarios - Plazo Pago. Comuniquese con tesorería',
          'warning',
          'Carga de Comprobante',
        ),
      );
    } else if (!dataContrato?.idTipoFactura) {
      dispatch(
        startAlerta(
          'El contrato no posee Condición de IVA en los Datos Bancarios. Comuniquese con tesorería',
          'warning',
          'Carga de Comprobante',
        ),
      );
    } else if (formValues.proveedor && cuentas.length === 0) {
      dispatch(
        startAlerta(
          'El Contrato de Proveedor no posee Plan de Cuentas en las Cuentas Contables. Comuniquese con tesorería',
          'warning',
          'Carga de Comprobante',
        ),
      );
    } else {
      handleClickOpen();
    }
  };

  return (
    <>
      {(permiso === null || validarSoloUnPermiso(permisosUser, permiso)) && (
        <>
          <Button
            variant={'contained'}
            color="primary"
            onClick={menuPrestador ? checkContrato : handleClickOpen}
          >
            Agregar Comprobante
          </Button>
          {open && (
            <Dialog
              open={open}
              fullWidth
              maxWidth={
                menuProforma &&
                  proformas.length > 0 &&
                  activeStep ===
                  STEPPER_EXPEDIENTE_PROFORMA_FORM.PROFORMAS_PENDEINTES
                  ? 'lg'
                  : 'md'
              }
            >
              <DialogContent>
                <StepperFormExpediente
                  formValues={formValues}
                  handleInputChange={handleInputChange}
                  setearValor={setearValor}
                  setearValores={setearValores}
                  setearVariosValores={setearVariosValores}
                  resetForm={resetForm}
                  handleSubmit={(data, stepperMenu) =>
                    handleSave(data, stepperMenu)
                  }
                  handleCancel={handleClose}
                  editable={true}
                  presupuesto={presupuesto}
                  cotizacion={cotizacion}
                  proforma={proforma}
                  letra={dataContrato?.idTipoFactura}
                  conEmbargo={conEmbargo}
                  toggleEmbargo={toggleEmbargo}
                />
              </DialogContent>
            </Dialog>
          )}
          {openModalInformacion && (
            <>
              <ModalInformacionExpediente
                open={openModalInformacion}
                tipoComprobanteDocumento={tipoComprobanteDocumentoMenu}
                closeModalHandler={() => {
                  setOpenModalInformacion(false);
                }}
                expediente={comprobanteTomado}
                onComprobante
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default AddButtonComprobante;
